import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { SettingsBackupRestore } from "@material-ui/icons";
import axios from "axios";

export default class RevokeCompute extends Component {
  constructor(props) {
    super();
    this.state = {
      showComputeModal: false,
      disableCompute: false,
    };
    this.handleshowComputeModal = this.handleshowComputeModal.bind(this);
  }

  handleshowComputeModal = (e) => {
    this.setState({ showComputeModal: !this.state.showComputeModal });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableCompute: true });
    axios.delete("api/compute_revoke/" + this.props.id).then((res) => {
      this.props.parentCallback(true);
      this.setState({ showComputeModal: false });
      this.setState({ disableCompute: false });
    });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-danger btn-sm float-right"
          title="Compute OT"
          onClick={this.handleshowComputeModal}
        >
          <SettingsBackupRestore />
        </button>
        <Modal
          size="md"
          show={this.state.showComputeModal}
          onHide={() =>
            this.setState({ showComputeModal: !this.state.showComputeModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Revoke Overtime Computation:<br/>{this.props.name}<br/>{this.props.period}</h4>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Are you sure to revoke computed overtime?</label>
                </div>
              </div>

              <div className="float-right">
                <button
                  disabled={this.state.disableCompute}
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                >
                  Revoke
                </button>
                <button
                  onClick={this.handleshowDeleteModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
